module.exports = "/virtual-football-league/img/jerseys/Red.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/Red.png
// module id = 183
// module chunks = 4